import { moduleForDisplayMode } from './module-for-display-mode'

export default function movieCardsModule(centre, title, entries, tabHeadings) {
  return moduleForDisplayMode(centre, {
    displayMode: 'FilteredCardList',
    title,
    entries,
    tabHeadings,
    centreSlug: centre.slug,
  })
}
